/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImportSession } from './ImportSession';
import {
    ImportSessionFromJSON,
    ImportSessionFromJSONTyped,
    ImportSessionToJSON,
    ImportSessionToJSONTyped,
} from './ImportSession';
import type { Order } from './Order';
import {
    OrderFromJSON,
    OrderFromJSONTyped,
    OrderToJSON,
    OrderToJSONTyped,
} from './Order';
import type { Organization } from './Organization';
import {
    OrganizationFromJSON,
    OrganizationFromJSONTyped,
    OrganizationToJSON,
    OrganizationToJSONTyped,
} from './Organization';

/**
 * 
 * @export
 * @interface Invoice
 */
export interface Invoice {
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Invoice
     */
    isActive?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    updatedAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    invoiceTotal?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Invoice
     */
    contractAmount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    invoiceTotalCurrency?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    description?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Invoice
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    organizationId?: string;
    /**
     * 
     * @type {Organization}
     * @memberof Invoice
     */
    organization?: Organization;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    importSessionId?: string | null;
    /**
     * 
     * @type {ImportSession}
     * @memberof Invoice
     */
    importSession?: ImportSession;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    externalOrderId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    externalOrderLineId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    invoiceNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    rawInvoiceData?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Invoice
     */
    orderId?: string | null;
    /**
     * 
     * @type {Order}
     * @memberof Invoice
     */
    order?: Order;
}

/**
 * Check if a given object implements the Invoice interface.
 */
export function instanceOfInvoice(value: object): value is Invoice {
    return true;
}

export function InvoiceFromJSON(json: any): Invoice {
    return InvoiceFromJSONTyped(json, false);
}

export function InvoiceFromJSONTyped(json: any, ignoreDiscriminator: boolean): Invoice {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'invoiceTotal': json['invoiceTotal'] == null ? undefined : json['invoiceTotal'],
        'contractAmount': json['contractAmount'] == null ? undefined : json['contractAmount'],
        'invoiceTotalCurrency': json['invoiceTotalCurrency'] == null ? undefined : json['invoiceTotalCurrency'],
        'description': json['description'] == null ? undefined : json['description'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'organizationId': json['organizationId'] == null ? undefined : json['organizationId'],
        'organization': json['organization'] == null ? undefined : OrganizationFromJSON(json['organization']),
        'importSessionId': json['importSessionId'] == null ? undefined : json['importSessionId'],
        'importSession': json['importSession'] == null ? undefined : ImportSessionFromJSON(json['importSession']),
        'externalOrderId': json['externalOrderId'] == null ? undefined : json['externalOrderId'],
        'externalOrderLineId': json['externalOrderLineId'] == null ? undefined : json['externalOrderLineId'],
        'invoiceNumber': json['invoiceNumber'] == null ? undefined : json['invoiceNumber'],
        'rawInvoiceData': json['rawInvoiceData'] == null ? undefined : json['rawInvoiceData'],
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'order': json['order'] == null ? undefined : OrderFromJSON(json['order']),
    };
}

export function InvoiceToJSON(json: any): Invoice {
    return InvoiceToJSONTyped(json, false);
}

export function InvoiceToJSONTyped(value?: Invoice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
        'invoiceTotal': value['invoiceTotal'],
        'contractAmount': value['contractAmount'],
        'invoiceTotalCurrency': value['invoiceTotalCurrency'],
        'description': value['description'],
        'date': value['date'] == null ? value['date'] : value['date'].toISOString(),
        'organizationId': value['organizationId'],
        'organization': OrganizationToJSON(value['organization']),
        'importSessionId': value['importSessionId'],
        'importSession': ImportSessionToJSON(value['importSession']),
        'externalOrderId': value['externalOrderId'],
        'externalOrderLineId': value['externalOrderLineId'],
        'invoiceNumber': value['invoiceNumber'],
        'rawInvoiceData': value['rawInvoiceData'],
        'orderId': value['orderId'],
        'order': OrderToJSON(value['order']),
    };
}

